/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductCategoties,
    GetProductDetailsByProductcatogeryID,
    GetMarketPricesForMarketPriceScreen,
    GetMarketsByGroupIDForMarketScreen,
    GetProductPricesByProductPriceIDFromMarketPriceScreen,
    SaveMarketPriceDetails,
    UpdateProductPriceDetails,
    GetAllGroupsForMarketScreen
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductDetailsByProductcatogeryID(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductDetailsByProductcatogeryIDMultiSelect', '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetMarketPricesForMarketPriceScreen(values) {
    let model = {
        groupID: values.groupID,
        productCategoryID: values.productCategoryID,
        productID: values.productID
    }
    const response = await CommonPost('/api/ProductSellingPrice/GetProductPricesForMarketPriceScreen', null, model);
    return response.data;
}

async function GetAllGroupsForMarketScreen() {
    const response = await CommonGet('/api/MarketScreen/GetAllGroupsForMarketScreen', null);
    return response.data;
}

async function GetMarketsByGroupIDForMarketScreen(groupID) {
    const response = await CommonGet('/api/MarketScreen/GetMarketsByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductPricesByProductPriceIDFromMarketPriceScreen(productPriceID) {
    const response = await CommonGet('/api/ProductSellingPrice/GetProductPriceByproductPriceID', 'productPriceID=' + parseInt(productPriceID));
    return response.data;
}
async function SaveMarketPriceDetails(model) {
    const response = await CommonPost('/api/ProductSellingPrice/SaveMarketPriceDetails', null, model);
    return response;
}

async function UpdateProductPriceDetails(values) {
    const response = await CommonPost('/api/ProductSellingPrice/UpdateProductPriceDetails', null, values);
    return response;
}


